import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  ApiDynamicPagesDeleteRequest,
  ApiDynamicPagesDeleteResponse,
  ApiDynamicPagesGetRequest,
  ApiDynamicPagesGetResponse,
  ApiDynamicPagesSetRequest,
  ApiDynamicPagesSetResponse, ApiDynamicPagesUpdateRequest, ApiDynamicPagesUpdateResponse
} from "@api/dynamic-pages";
import {Observable} from "rxjs";
import {EnvironmentService} from "@iw-shop/core//services/environment.service";

@Injectable({
  providedIn: 'root'
})
export class DynamicPageService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
  }

  set(data: ApiDynamicPagesSetRequest['params']['data']): Observable<ApiDynamicPagesSetResponse> {
    const body: ApiDynamicPagesSetRequest = {
      id: 'setDynamicPages#INVALID_PARAMS',
      command: 'dynamicPages/set',
      params: {
        data
      }
    };
    return this.http.post<ApiDynamicPagesSetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  get(params: ApiDynamicPagesGetRequest['params']): Observable<ApiDynamicPagesGetResponse> {
    const body: ApiDynamicPagesGetRequest = {
      id: 'getDynamicPages',
      command: 'dynamicPages/get',
      params: params
    };
    return this.http.post<ApiDynamicPagesGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  update(data: ApiDynamicPagesUpdateRequest['params']['data']): Observable<ApiDynamicPagesUpdateResponse> {
    const body: ApiDynamicPagesUpdateRequest = {
      id: 'updateDynamicPages#INVALID_PARAMS',
      command: 'dynamicPages/update',
      params: {
        data
      }
    };
    return this.http.post<ApiDynamicPagesUpdateResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  delete(id: string): Observable<ApiDynamicPagesDeleteResponse> {
    const body: ApiDynamicPagesDeleteRequest = {
      id: 'deleteDynamicPage',
      command: 'dynamicPages/delete',
      params: {
        data: {
          id
        }
      }
    };
    return this.http.post<ApiDynamicPagesDeleteResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }
}
